/* eslint-disable max-len */

// SKIP LOGIC
export const SKIP_LOGIC_NO_QUESTIONS_MESSAGE = 'Please add a multi select, single select, rating scale or preference question to add skip logic.';
export const SKIP_LOGIC_SUBSCRIPTION = 'Skip logic can only be applied to multi select, single select, rating scale and preference questions';
export const SKIP_LOGIC_ZERO_STATE = 'Skip logic is not enabled for this page.';
export const SKIP_LOGIC_ALLOWED_QUESTIONS = ['multiple_select', 'single_select', 'range', 'preference'];

export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const SUPPORTED_FORMATS = ['image/jpeg', 'image/png'];
export const SUPPORTED_IMAGE_FORMATS = ['image/jpeg', 'image/png'];

export const MAX_VIDEO_FILE_SIZE = 500 * 1024 * 1024;
export const SUPPORTED_VIDEO_FORMATS = ['video/mp4'];
